import { Box, Grid } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import LeadCampaignApi from "../../../../../infrastructure/api/leadCampaignApi";
import MarketGrowthPageShell from "../components/MarketGrowthPageShell";
import MarketGrowthStatCard from "../components/MarketGrowthStatCard";
import {
  LeadCampaignFunnelSection,
  RankList,
  pick,
} from "./components/LeadCampaignFunnelSection";

const LeadCampaignDashboardPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await LeadCampaignApi.getDashboard();
      const normalized = LeadCampaignApi.normalize(res, "بارگذاری داشبورد ناموفق بود.");
      if (normalized.error) {
        setError(normalized.error);
        setData(null);
        return;
      }
      setData(normalized.data);
    } catch (e) {
      setError(e?.message || "خطا در بارگذاری");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const funnel = pick(data, "funnel", "Funnel");
  const topCampaigns = pick(data, "topCampaigns", "TopCampaigns") || [];
  const worstCampaigns = pick(data, "worstCampaigns", "WorstCampaigns") || [];
  const topGroups = pick(data, "topGroups", "TopGroups") || [];

  return (
    <MarketGrowthPageShell
      title="داشبورد جذب متقاضی"
      description="نمای کلی گروه‌های مخاطب، قیف تبدیل و عملکرد کمپین‌ها."
      loading={loading}
      error={error}
      onRetry={load}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <MarketGrowthStatCard label="گروه‌های مخاطب" value={pick(data, "totalGroups", "TotalGroups") ?? 0} />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <MarketGrowthStatCard label="گروه‌های فعال" value={pick(data, "activeGroups", "ActiveGroups") ?? 0} />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <MarketGrowthStatCard label="کل مخاطبین" value={pick(data, "totalContacts", "TotalContacts") ?? 0} />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <MarketGrowthStatCard label="مخاطبین معتبر" value={pick(data, "validContacts", "ValidContacts") ?? 0} />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <MarketGrowthStatCard label="ثبت‌نام‌شده" value={pick(data, "registeredContacts", "RegisteredContacts") ?? 0} />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <MarketGrowthStatCard label="کل کمپین‌ها" value={pick(data, "totalCampaigns", "TotalCampaigns") ?? 0} />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <MarketGrowthStatCard label="پیش‌نویس" value={pick(data, "draftCampaigns", "DraftCampaigns") ?? 0} />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <MarketGrowthStatCard label="زمان‌بندی‌شده" value={pick(data, "scheduledCampaigns", "ScheduledCampaigns") ?? 0} />
        </Grid>
      </Grid>

      <LeadCampaignFunnelSection funnel={funnel} />

      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} md={4}>
          <RankList title="برترین کمپین‌ها" items={topCampaigns} rateKey="requestRate" />
        </Grid>
        <Grid item xs={12} md={4}>
          <RankList title="ضعیف‌ترین کمپین‌ها" items={worstCampaigns} rateKey="requestRate" />
        </Grid>
        <Grid item xs={12} md={4}>
          <RankList title="برترین گروه‌ها" items={topGroups} rateKey="requestRate" />
        </Grid>
      </Grid>
      <Box sx={{ mt: 2 }} />
    </MarketGrowthPageShell>
  );
};

export default LeadCampaignDashboardPage;
